import styled from "styled-components";
import { TEXT_PRIMARY, TEXT_SECONDARY } from "./palette";

// 分析頁共用的視覺骨架：白色卡片 + 幣別 chip + facet 標頭

export const Card = styled.div`
  background: #fff;
  border: 1px solid rgba(11, 11, 11, 0.06);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  padding: 1.25em 1.5em;
`;

export const CardTitle = styled.h3`
  margin: 0 0 1em;
  font-size: 15px;
  font-weight: 600;
  color: ${TEXT_PRIMARY};
`;

export const CurrencyChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 10px;
  border-radius: 999px;
  background: #f0efec;
  color: ${TEXT_SECONDARY};
  font-size: 12px;
  font-weight: 600;
`;

export const FacetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75em;
  margin-bottom: 10px;
`;

export const FacetStats = styled.span`
  font-size: 12px;
  color: ${TEXT_SECONDARY};
`;

// facet 之間以 hairline 分隔（第一個不需要）
export const FacetWrapper = styled.div`
  &:not(:first-child) {
    border-top: 1px solid #f0efec;
    padding-top: 1.25em;
    margin-top: 1.25em;
  }
`;
